import Joi from 'joi-browser';
import axios from "axios";
import queryString from 'query-string';
import { WAPIAddress } from "constants/config";
import * as wapiKeys from '../../../apiKeys';

const wapiKey = process.env.APP_ENV === 'development'? wapiKeys.dev_key : wapiKeys.prod_key;
const STATUS = ['sendWithoutCheck', 'sendIfUserExist', 'sendIfUserNotExist']

export const schema = Joi.object().keys({
  phone: Joi.string().required(),
  check_phone: Joi.string().valid(STATUS).required()
});

export default function sendUsernameVerification(params) {
  let validateResult = Joi.validate(params, schema);

  if (validateResult.error) {
    return new Promise((resolve, reject) => {
      reject(validateResult);
    });
  }
  let query = queryString.stringify({
    phone: params.phone,
    check_phone: STATUS.indexOf(params.check_phone),
    language: localStorage.getItem('language')==='CN'? 'zh' : 'en'
  });

  return new Promise((resolve, reject) => {
    axios.put(WAPIAddress, {'uri': `/mobile_verification/?${query}`,
      'method': 'GET',
      'token': localStorage.getItem('token'),
      'wapiKey': wapiKey,
    })
      .then((res) => {
        resolve(res.data);
      })
        .catch((err) => {
          reject(err);
        })
  })
}


// WEBPACK FOOTER //
// ./src/controllers/controllers/user/sendUsernameVerification.js